export const initialTeamState = { name: '', isEditable: true }

export { default as useTeamReducer } from './useTeamReducer'
export { default as teamReducer, initialState } from './teamReducer'
export { default as TeamProvider } from './TeamProvider'
